import jquery from "jquery";
import { addToGlobalThisRet, htmlToElement } from "@plugins";

window.$ = window.jQuery = jquery;

class ItcCustomSelect {
    constructor(target, options) {
        this.element = typeof target === "string" ? document.querySelector(target) : target;
        this.target = this.element.querySelector("[data-select=target]");
        this.search = this.target.dataset.search;

        this._setDefaults(options);
        this._init();
        this._hideTargetSelect();
    }

    static hideOpenSelect() {
        document.addEventListener("click", (e) => {
            if (
                !e.target.closest("[data-select=toggle]") &&
                !e.target.closest("[data-select=dropdown]")
            ) {
                const elsActive = document.querySelectorAll(".custom-select--show");
                elsActive.forEach((el) => {
                    el.classList.remove("custom-select--show");

                    if (el.classList.contains("custom-select--top-orient")) {
                        el.classList.remove("custom-select--top-orient");
                    }
                });
            }
        });
    }

    _setDefaults(options) {
        const defaults = {
            template(selectOptions) {
                return `
                    <div class="custom-select__wrap">
                        <button
                            type="button"
                            class="custom-select__toggle"
                            data-select="toggle"
                        >${selectOptions.selectedContent}</button>
                        <i class="custom-select__icon"></i>
                        <div class="custom-select__dropdown ${selectOptions.dropdownAdditionalClasses}" data-select="dropdown">
                            <i class="custom-select__dropdown-arrow"></i>
                            ${selectOptions.search}
                            <div class="custom-select__dropdown-list">
                                <div class="custom-select__options">${selectOptions.items}</div>
                            </div>
                        </div>
                    </div>`;
            },
        };
        Object.assign(this, defaults, options);
    }

    _init() {
        if (!this.element.querySelector(".custom-select__wrap")) {
            this._createCustomSelect();
            this.listener = this._initListeners.bind(this);
            this.element.addEventListener("click", this.listener);
        } else {
            this.element.querySelector(".custom-select__wrap").remove();
            this._createCustomSelect();
        }

        if (this.search) {
            this._searchInit();
        }
    }

    _hideTargetSelect() {
        this.target.style.display = "none";
    }

    _createCustomSelect() {
        const options = this._createDropdown();

        if (options.selectedContentArray && options.selectedContentArray.length > 0) {
            options.selectedContent = options.selectedContentArray.join(", ");
        }

        this.customSelect = htmlToElement(
            this.template({
                selectedContent: options.selectedContent || "",
                items: options.dropdownOptions.join(""),
                search: options.search ||"",
                dropdownAdditionalClasses: options.search
                    ? "custom-select__dropdown--with-search"
                    : "",
            }),
        );

        this.target.after(this.customSelect);
    }

    _createDropdown() {
        const options = {};
        const dropdownOptions = [];
        const selectedContentArray = [];

        Array.from(this.target.options).forEach((option) => {
            if (!this.target.multiple) {
                if (option.selected) {
                    options.selectedValue = option.value;
                    options.selectedIndex = option.index;
                    options.selectedContent = option.text;
                }

                dropdownOptions.push(`
                <div
                    class="custom-select__option${
                        option.selected ? " custom-select__option--selected" : ""
                    }"
                    data-value="${option.value}"
                    data-index="${option.index}"
                    data-select="option"
                >${option.text}</div>`);
            } else {
                if (option.selected) {
                    options.selectedValue = option.value;
                    options.selectedIndex = option.index;
                    selectedContentArray.push(option.text);
                }

                dropdownOptions.push(`
                <label class="custom-checkbox custom-select__checkbox" for="${option.value}-${
                    option.index
                }" data-select="checkbox">
                    <input
                        id="${option.value}-${option.index}"
                        class="custom-checkbox__input"
                        type="checkbox"
                        data-value="${option.value}"
                        data-index="${option.index}"
                        ${option.selected ? "checked" : ""}
                    >
                    <i class="custom-checkbox__icon custom-select__checkbox-icon"></i>
                    ${option.text}
                </label>
                `);
            }
        });

        if (this.search) {
            options.search = `
                <div class="custom-select__search">
                    <input class="input custom-select__search-input" type="text" placeholder="Поиск...">
                    Найдено
                </div>
            `;
        }

        options.dropdownOptions = dropdownOptions;
        options.selectedContentArray = selectedContentArray;

        return options;
    }

    _searchInit() {
        const searchInput = this.element.querySelector(".custom-select__search-input");
        const searchItems = this.element.querySelectorAll(".custom-select__checkbox");

        if (searchInput) {
            searchInput.addEventListener("keyup", () => {
                const searchInputUpper = searchInput.value.toUpperCase();
                let searchItems = this.element.querySelectorAll(".custom-select__checkbox");

                if (!searchItems || searchItems.length === 0) {
                    searchItems = this.element.querySelectorAll(".custom-select__option");
                }

                if (searchItems.length > 0) {
                    searchItems.forEach((item) => {
                        if (item.textContent.trim().toUpperCase().indexOf(searchInputUpper) > -1) {
                            item.style.display = "";
                        } else {
                            item.style.display = "none";
                        }
                    });
                }
            });
        }
    }

    _initListeners(e) {
        const type = e.target.closest("[data-select]").dataset.select;

        if (type === "toggle") {
            this._toggle();
        } else if (type === "option") {
            this._changeValue(e.target, type);
        } else if (type === "checkbox") {
            e.preventDefault();
            this._changeValue(e.target, type);
        }
    }

    _setOrientation() {
        const isTopOrient = this.element.classList.contains("custom-select--top-orient");

        const elementRect = this.element.getBoundingClientRect();
        const elementBottom = elementRect.top + elementRect.height;

        const viewportHeight = window.innerHeight;
        const distanceToBottom = viewportHeight - elementBottom;

        const hasParentTable = this.element.closest("table");

        if (hasParentTable) {
            const parentBottom = hasParentTable.getBoundingClientRect().bottom;

            const dropdown = this.element.querySelector(".custom-select__dropdown");
            const dropdownHeight = dropdown.getBoundingClientRect().height;

            if (dropdownHeight + elementBottom > parentBottom) {
                this.element.classList.add("custom-select--top-orient");
            }
        }

        if (distanceToBottom < 200 && !isTopOrient) {
            this.element.classList.add("custom-select--top-orient");
        }

        if (this.element.offsetWidth < 500) {
            this.element.setAttribute("style", "--custom-select-dropwown-inline-indent: -10%;");
        }
    }

    _toggle() {
        this.element.classList.contains("custom-select--show") ? this._close() : this._show();
    }

    _show() {
        document.querySelectorAll(".custom-select--show").forEach((el) => {
            el.classList.remove("custom-select--show");
        });
        this._setOrientation();
        this.element.classList.add("custom-select--show");
    }

    _close() {
        this.element.classList.remove("custom-select--show");

        if (this.element.classList.contains("custom-select--top-orient")) {
            this.element.classList.remove("custom-select--top-orient");
        }
    }

    _changeValue(elem, type) {
        if (type === "checkbox") {
            const input = elem.querySelector("input");

            if (input.checked === true) {
                input.checked = false;
                this._toggleOptionSelected(input.dataset.value, 'remove');
                this._updateTogglerValue(elem, false);
            } else {
                input.checked = true;
                this._toggleOptionSelected(input.dataset.value, 'add');
                this._updateTogglerValue(elem, true);
            }
        } else {
            this._updateTogglerValue(elem);
            this._updateOptionsList(elem);
            this.target.value = elem.dataset.value;
            this._close();
        }

        this.target.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }

    _updateTogglerValue(elem, selected) {
        const target = this.element.querySelector("[data-select=toggle]");
        const targetText = target.textContent.trim();
        const elemText = elem.textContent.trim();

        if (elem.dataset.select === "option") {
            target.textContent = elemText;
        } else {
            if (selected) {
                if (!targetText.includes(elemText)) {
                    if (targetText.length > 0) {
                        target.textContent = targetText + ", " + elemText;
                    } else {
                        target.textContent = elemText;
                    }
                }
            } else {
                const newText = targetText
                    .split(", ")
                    .filter((item) => item !== elemText)
                    .join(", ");

                target.textContent = newText;
            }
        }
    }

    _toggleOptionSelected(value, task) {
        const targetOption = this.target.querySelector(`option[value="${value}"]`);

        if (task === 'add') {
            targetOption.setAttribute("selected", true);
        }

        if (task === 'remove') {
            targetOption.removeAttribute("selected");
        }
    }

    _updateOptionsList(target) {
        const selectedOption = this.element.querySelector(".custom-select__option--selected");

        if (selectedOption) {
            selectedOption.classList.remove("custom-select__option--selected");
        }

        target.classList.add("custom-select__option--selected");
    }
}

function initCustomSelects(target) {
    if (target) {
        new ItcCustomSelect(target);
    } else {
        const selects = [...document.querySelectorAll("[data-custom-select]")];

        if (selects.length > 0) {
            for (const select of selects) {
                new ItcCustomSelect(select);
            }

            ItcCustomSelect.hideOpenSelect();
        }
    }
}

window.addEventListener("load", () => initCustomSelects());

addToGlobalThisRet(initCustomSelects, "initCustomSelects");
